import { CSSProperties, ReactElement } from "react";
import { Row } from "@tanstack/react-table";
import { TableRow } from "@/components/atoms/table";

interface TableBodyProps<TData> {
  rows: Row<TData>[];
  onRowClick?: (data: TData) => void;
  getRowClassName?: (data: TData) => string;
  getRowStyle?: (data: TData) => CSSProperties;
  rowWrapper?: (data: TData, tr: ReactElement) => ReactElement;
  emptyMessage?: string;
}

export function TableBody<TData>({
  rows,
  onRowClick,
  getRowClassName,
  getRowStyle,
  rowWrapper,
  emptyMessage = "No hay datos disponibles",
}: TableBodyProps<TData>) {
  if (rows.length === 0) {
    return (
      <tbody>
        <tr>
          <td
            colSpan={100}
            className="px-4 py-8 text-center text-sm text-muted-foreground"
          >
            {emptyMessage}
          </td>
        </tr>
      </tbody>
    );
  }

  return (
    <tbody className="divide-y divide-border">
      {rows.map((row) => (
        <TableRow key={row.id} row={row} onRowClick={onRowClick} getRowClassName={getRowClassName} getRowStyle={getRowStyle} rowWrapper={rowWrapper} />
      ))}
    </tbody>
  );
}
